/**
 * @Author 22030124/xieyq
 * @Date 2023-11-20 17:42:19
 * @Description 工作台相关接口
 */

import request from '@/utils/request'

/**
 * 获取工作台列表
 * @returns {Promise}
 */
export function requestWorkbenchList() {
  return request({
    url: '/workplace/api/workplace/list',
    method: 'GET'
  })
}

/**
 * 获取工作台列表
 * @returns {Promise}
 */
export function requestWorkbenchPage(params) {
  return request({
    url: '/workplace/api/workplace/page',
    method: 'GET',
    params
  })
}

/**
 * 获取分类下工作台数量
 * @returns {Promise}
 */
export function requestWorkbenchCount(params) {
  return request({
    url: '/workplace/api/workplace/countByCategory',
    method: 'GET',
    params
  })
}

/**
 * 新增工作台
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestCreateWorkbench(data) {
  return request({
    url: '/workplace/api/workplace/create',
    method: 'POST',
    data
  })
}

/**
 * 更新工作台
 * @param {*} data 请求体参数
 * @returns {Promise}
 */
export function requestUpdateWorkbench(data) {
  return request({
    url: '/workplace/api/workplace/update',
    method: 'POST',
    data
  })
}

/**
 * 设置默认工作台
 * @returns {Promise}
 */
export function requestSetWorkbenchDefault(params) {
  return request({
    url: '/workplace/api/workplace/setDefault',
    method: 'POST',
    params
  })
}

/**
 * 删除工作台
 * @param {String} workplaceId 工作台id
 * @returns {Promise}
 */
export function requestWorkbenchDelete(workplaceId) {
  return request({
    url: '/workplace/api/workplace/delete',
    method: 'POST',
    params: {
      workplaceId
    }
  })
}

/**
 * 发布工作台
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestPublishWorkbench(data) {
  return request({
    url: '/workplace/api/workplace/deploy',
    method: 'POST',
    data
  })
}

/**
 * 工作台状态
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestWorkbenchStatus(data) {
  return request({
    url: '/workplace/api/workplace/status',
    method: 'POST',
    data
  })
}

/**
 * 查询工作台详情
 * @param {String} workplaceId 工作台id
 * @returns {Promise}
 */
export function requestDetailWorkbench(workplaceId) {
  return request({
    url: `/workplace/api/workplace/detail/${workplaceId}`,
    method: 'GET'
  })
}

/**
 * 设计工作台
 * @param {Object} data 请求体参数
 * @returns {Promise}
 */
export function requestDesignWorkbench(data) {
  return request({
    url: '/workplace/api/workplace/develop',
    method: 'POST',
    data
  })
}

/**
 * 请求组件列表
 * @returns {Promise}
 */
export function requestComponents(params) {
  return request({
    url: '/workplace/api/block/groupByCategory',
    method: 'GET',
    params
  })
}

/**
 * 请求工作台权限
 * @returns {Promise}
 */
export function requestWorkbenchRights(workplaceId) {
  return request({
    url: `/workplace/api/workplace/visibility/${workplaceId}`,
    method: 'GET'
  })
}
/**
 * 设置工作台权限
 * @returns {Promise}
 */
export function requestWorkbenchRightsConfig(data) {
  return request({
    url: `/workplace/api/workplace/visibility/config`,
    method: 'POST',
    data
  })
}
